import { Active, Inactive } from "@pulse/features/Sections";
import { ActiveQuestionLayout, InactiveQuestionLayout } from "../QuestionLayouts";
import { GradeLine } from "./Grade";
import { useEditQuestionForm } from "../hooks";
import { PULSE_FIELD_LIMITS } from "@pulse/features/pulseFieldLimits";

function RatingQuestionEdit() {
    const form = useEditQuestionForm();
    return (
        <>
            <form.AppField name="questionText">
                {(field) => (
                    <field.TextArea autoFocus maxCharacters={PULSE_FIELD_LIMITS.question.text} />
                )}
            </form.AppField>
            <GradeLine />
        </>
    );
}

function RatingQuestionDisplay() {
    return (
        <>
            <GradeLine />
        </>
    );
}

export default function RatingQuestion() {
    return (
        <>
            <Active>
                <ActiveQuestionLayout>
                    <RatingQuestionEdit />
                </ActiveQuestionLayout>
            </Active>
            <Inactive>
                <InactiveQuestionLayout>
                    <RatingQuestionDisplay />
                </InactiveQuestionLayout>
            </Inactive>
        </>
    );
}
